<section>

  <p-messages key="reindexSuccessMsg" [closable]="true"></p-messages>

  <h2 class="h4 my-3 mt-3">Reindex Indices By Date Range</h2>
  <p-messages></p-messages>
  <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
    <thead>
      <tr>
        <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
        <th>Index</th>
      </tr>
    </thead>
    <tbody>
      <tr><td style="width:30px"><input type="checkbox" value="{{checkIdxAdr}}" (change)="checkIdxAdr = !checkIdxAdr" /></td><td>Addresses</td></tr>
      <tr><td style="width:30px"><input type="checkbox" value="{{checkIdxCgc}}" (change)="checkIdxCgc = !checkIdxCgc" /></td><td>Crime Gun Cases</td></tr>
    </tbody>
  </table>
  <div class="p-2 font-size-sm">
    <button type="button" class="btn btn-success" [disabled]="!isIdxChecked()" (click)="showConfirmDialogClicked(1)">Reindex Last 48 Hours</button>
    <button type="button" class="btn btn-success ms-5" [disabled]="!isIdxChecked()" (click)="showConfirmDialogClicked(2)">Reindex All</button>
  </div>

  <hr />

  <h2 class="h4 my-3 mt-3">Reindex Crime Gun Cases by CGID</h2>
  <div class="p-2 font-size-sm">
    <div><span><i>Comma seperated CGIDs</i></span></div>
    <input type="text" style="width:50%" [(ngModel)]="cgids" />
    <button type="button" class="btn btn-success ms-2" [disabled]="cgids.length < 1" (click)="reindexByCGID()">Reindex CGID(s)</button>
  </div>

  <hr />

  <h2 class="h4 my-3 mt-3">Reindex Crime Gun Cases by RMS Event ID</h2>
  <div class="p-2 font-size-sm">
    <div><span><i>Comma seperated RMS Event IDs</i></span></div>
    <input type="text" style="width:50%" [(ngModel)]="rmsids" />
    <button type="button" class="btn btn-success ms-2" [disabled]="rmsids.length < 1" (click)="reindexByRMSID()">Reindex RMS ID(s)</button>
  </div>

  <hr />

  <h2 class="h4 my-3 mt-3">Reindex Crime Gun Cases by Agency ORI</h2>
  <div class="p-2 font-size-sm">
    <div><span><i>Agency ORI</i></span></div>
    <input type="text" style="width:50%" [(ngModel)]="agencyOri" />
    <button type="button" class="btn btn-success ms-2" [disabled]="agencyOri.length < 1" (click)="reindexByAgencyORI()">Reindex Agency ORI</button>
  </div>

  <hr />

  <h2 class="h4 my-3 mt-3">Reindex Ballistic Evidence</h2>
  <div class="p-2 font-size-sm">
    <div><span><i>In the last N minutes</i></span></div>
    <input type="text" style="width:50%" [(ngModel)]="beMinutes" />
    <button type="button" class="btn btn-success ms-2" [disabled]="beMinutes.length < 1" (click)="reindexBallisticEvidence()">Reindex Ballistic Evidence</button>
  </div>


  <!--Confirmation dialog -->
  <p-dialog header="Continue with Indexing?" [(visible)]="showConfirmDialog" [modal]="true" [style]="{width: '50vw'}" [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
    <div class="alert alert-info ness-alert-with-icon">
      <div>
        <p class="mb-1" *ngIf="buttonMode==2 && checkIdxCgc"><small><i aria-hidden="true" class="p-1 me-1 text-danger fas fa-exclamation-triangle fa-1x"></i> <span class="fw-bold text-danger">WARNING: A complete reindex of crime gun cases will take between 30-60 minutes.</span> </small></p>
        <p class="mb-0"><small><i aria-hidden="true" class="p-1 me-1 fas fa-info-circle fa-1x"></i> Reindexing may take some time, <span class="fw-bold">please do not submit multiple reindex requests</span> within short time periods.</small></p>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-play" (click)="confirmDialogResponseClicked(true)" label="Continue" styleClass="p-button-text"></p-button>
      <p-button icon="pi pi-times" (click)="confirmDialogResponseClicked(false)" label="Cancel" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>

</section>
